import styled from 'styled-components';
// @ts-ignore
// eslint-disable-next-line @typescript-eslint/no-redeclare
import {Icons} from '@sede-enterprise/shell-ds-react-framework'

export const ButtonActionContainer = styled.div`
  .shell-button.shell-button-icon-left {
    padding-left: 0;
  }
  .shell-button-renderer{
    margin:4px 0px 4px 4px;
    padding:0px;
    border-radius:2px;
    outline:none;
    width:9rem;
  }
  .shell-button-renderer span span{
    font-weight:bold;
    font-size:0.75rem;
    margin-left:-2px;
  }
  .shell-button-renderer svg{
    height:24px;
    width:24px;
    margin-left:-10px;
  }
`;

export const NonButtonActionContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-content: flex-end;
`;

export const NonButton = styled.div`
  flex: 1;
  padding-left: 0.2rem;
`;

export const CrossIconAction = styled(Icons.Cross)`
  &.shell-icon {
    display: inline-block;
    margin-top: 0.2rem;
    flex-shrink:0;
    width:25px;
    line-height:25px;
  }
  path{
    fill:red;
  }
`;

export const ArrowRightIconAction = styled(Icons.ArrowRight)`
&.shell-icon {
  display: inline-block;
  margin-top: 0.2rem;
  flex-shrink:0;
  width:25px;
  line-height:25px;
}
path{
  fill:red;
}
`;

export const EditIconAction = styled(Icons.Edit)`
&.shell-icon {
  display: inline-block;
  margin-top: 0.2rem;
  flex-shrink:0;
  width:25px;
  line-height:25px;
}
path{
  fill:red;
}
`;

export const ViewIconAction = styled(Icons.EyeHollow)`
&.shell-icon {
  display: inline-block;
  margin-top: 0.2rem;
  flex-shrink:0;
  width:25px;
  line-height:25px;
}
path{
  fill:red;
}
`;

export const ViewResultsIconAction = styled(Icons.Content)`
&.shell-icon {
  display: inline-block;
  margin-top: 0.2rem;
  flex-shrink:0;
  width:25px;
  line-height:25px;
}
path{
  fill:black;
}
`;

export const DownloadResultsIconAction = styled(Icons.SwapVertical)`
&.shell-icon {
  display: inline-block;
  margin-top: 0.2rem;
  flex-shrink:0;
  width:25px;
  line-height:25px;
}
path{
  fill:black;
}
`;